import './infobubble'
import './markerclusterer'

var my_lat = '';
var my_lng = '';
var api_url = 'https://courtfinder.wpengine.com/'

function getLocation() {
	if ( typeof set_postal_code !== 'undefined' && set_postal_code != '') {
		jQuery.post('https://maps.googleapis.com/maps/api/geocode/json?address=' + set_postal_code + '&key=AIzaSyBlVVc5Q_KicH5hFepm3rcMYhgaVqKOZGM', function ( data ) {
			if (data.status == 'ZERO_RESULTS') {
				set_postal_code = '';
				jQuery('#courtfinder_no_location_error').show(); /*Needs to be created on the calling page*/
			} else {
				my_lat = data.results[0].geometry.location.lat;
				my_lng = data.results[0].geometry.location.lng;
				getLocation2();
			}
		});
	} else {
		jQuery.post( "https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyBlVVc5Q_KicH5hFepm3rcMYhgaVqKOZGM", function( data ) {
		  my_lat = data.location.lat;
		  my_lng = data.location.lng;
		  getLocation2();
		});
	}
}

function getLocation2() {

	if (!my_lat || my_lat == '') {
		if ( navigator.geolocation ) {
			vm.state_loading = true;
			navigator.geolocation.getCurrentPosition( showPosition, geo_errors );
		} else {
			alert( "Geolocation is not supported by this browser." )
		}
	} else {
		vm.get_courts_around();
	}

}

function geo_errors(error) {
	switch(error.code) {
        case error.PERMISSION_DENIED:
			alert("User denied the request for Geolocation.");
            break;
        case error.POSITION_UNAVAILABLE:
            alert("Location information is unavailable.");
            break;
        case error.TIMEOUT:
            alert("The request to get user location timed out.");
            break;
        case error.UNKNOWN_ERROR:
            alert('An unknown error occurred.');
            break;
    }
    vm.get_courts_all();
}

function showPosition(position) {

    my_lat = position.coords.latitude;
    my_lng = position.coords.longitude;

    vm.get_courts_around();
}

var map;
var markers = [];
var prev_info = false;
var mark_clust = null;
var info_bubble = null;

var cluster_options = {
    styles: [
        {
            width: 45,
            height: 45,
            url: assets_src + "/svg/map/cluster-45.svg",
            textColor: '#ffffff'
        },
        {
            width: 55,
            height: 55,
            url: assets_src + "/svg/map/cluster-55.svg",
            textColor: '#ffffff'
        },
        {
            width: 65,
            height: 65,
            url: assets_src + "/svg/map/cluster-65.svg",
            textColor: '#ffffff'
        },
        {
            width: 75,
            height: 75,
            url: assets_src + "/svg/map/cluster-75.svg",
            textColor: '#ffffff'
        },
        {
            width: 85,
            height: 85,
            url: assets_src + "/svg/map/cluster-5.png",
            textColor: '#ffffff'
        },
        {
            width:95,
            height: 95,
            url: assets_src + "/svg/map/cluster-6.png",
            textColor: '#ffffff'
        }
    ]
}

function CenterControl(controlDiv, map) {

  // Set CSS for the control border.
  var controlUI = document.createElement('div');
  controlUI.style.backgroundColor = '#fff';
  controlUI.style.border = '2px solid #fff';
  controlUI.style.borderRadius = '2px';
  controlUI.style.boxShadow = '0px 1px 4px -1px rgba(0, 0, 0, 0.298039)';
  controlUI.style.cursor = 'pointer';
  controlUI.style.margin = '14px 10px 10px 10px';
  controlUI.style.textAlign = 'center';
  controlUI.title = 'Click to recenter the map';
  controlDiv.appendChild(controlUI);

  // Set CSS for the control interior.
  var controlText = document.createElement('div');
  controlText.style.color = 'rgb(95,95,95)';
  controlText.style.fontFamily = 'Roboto,Arial,sans-serif';
  controlText.style.fontSize = '14px';
  controlText.style.lineHeight = '27px';
  controlText.style.fontWeight = "600";
  controlText.style.paddingLeft = '5px';
  controlText.style.paddingRight = '5px';
  controlText.innerHTML = 'Suggest a court';
  controlUI.appendChild(controlText);

  // Setup the click event listeners: simply set the map to Chicago.
  controlUI.addEventListener('click', function() {
    location.href = "http://www.tenniscanada.com/suggest-a-court/";
  });

}

function initMap() {

	var map_holder = document.getElementById('courtfinder__map')

	if( typeof(map_holder) == 'undefined' || map_holder == null || map_holder.length == '0' )
		return;

    map = new google.maps.Map(map_holder, {
        center: { lat: -34.397, lng: 150.644 },
        zoom: 2,
		mapTypeControl: false,
		streetViewControl: false,
		scrollwheel: false
    });
      // Create the DIV to hold the control and call the CenterControl()
      // constructor passing in this DIV.
      var suggestCourt = document.createElement('div');
      var centerControl = new CenterControl(suggestCourt, map);

      suggestCourt.index = 1;
      map.controls[google.maps.ControlPosition.TOP_RIGHT].push(suggestCourt);

    map.set('styles', [
    {
        "featureType": "administrative",
        "elementType": "labels.text",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#919191"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "administrative.country",
        "elementType": "all",
        "stylers": [
            {
                "color": "#c4c4c4"
            }
        ]
    },
    {
        "featureType": "administrative.country",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "saturation": "92"
            },
            {
                "lightness": "6"
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "gamma": "8.73"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#f3fbe8"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#f3fbe8"
            }
        ]
    },
    {
        "featureType": "poi.sports_complex",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#eec6c6"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ececec"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "simplified"
            },
            {
                "color": "#ececec"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ededed"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#46bcec"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#04a0e9"
            },
            {
                "saturation": "-31"
            },
            {
                "lightness": "82"
            },
            {
                "gamma": "1.88"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#b6b6b6"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    }
]);

    info_bubble = new InfoBubble({
        shadowStyle: false,
        padding: 20,
        borderRadius: 0,
        backgroundColor: base_color,
        minWidth: 318,
        minHeight: 170,
        maxHeight: 200,
        disableAutoPan: false,
        closeSrc: assets_src +"svg/map/close.svg",
        hideCloseButton: false,
        borderWidth: 1,
        borderColor: '#ffffff',
        backgroundClassName: 'courtfinder__map__infobox',
        disableAnimation: true,
		overflow: 'visible'
    });

	google.maps.event.addListener(info_bubble,'closeclick',function(){
		vm.marker = '';
	});


}

//var marker_icon = new google.maps.MarkerImage( assets_src + "/svg/map/map-marker.png", null, null, null, new google.maps.Size(30,40));
var marker_icon = {
    path :"M11,0.9c-6.1,0-11,4.9-11,11c0,2.7,1,5.3,2.8,7.3L11,28l8.2-8.8c1.8-2,2.8-4.6,2.8-7.3C22,5.8,17,0.9,11,0.9z M11,15.3c-1.9,0-3.5-1.6-3.5-3.5S9,8.4,11,8.4c1.9,0,3.5,1.6,3.5,3.5S12.9,15.3,11,15.3z",
    fillColor: base_color,
    strokeColor:'white',
    strokeAlignment:'center',
    fillOpacity: 1,
    anchor: new google.maps.Point(11,28),
    strokeWeight: 1.6,
    scale: 1.1
}

function addMarker(location, content ) {

    var marker = new google.maps.Marker({
        position: location,
		icon: marker_icon,
        title: String(content.id)
    });

    var latLng = new google.maps.LatLng( location );

    var fn = markerClickFn( content, latLng );
    google.maps.event.addListener( marker, 'click', markerClickFn( content, latLng, 'clicking' ) );
    google.maps.event.addListener( marker, 'mouseover', markerClickFn( content, latLng, 'hovering' ) );

    markers.push(marker);

}

function displayMarkers(data) {
console.log( info_bubble )
console.log( map )
    markers = [];

    info_bubble.close( map );
    vm.marker = '';

    for ( var i = 0; i < data.length; i++) {

        var lat = data[i].address.lat;
        var lng = data[i].address.lng;

        if ( typeof lat == 'string' ) {
           lat = parseFloat( lat );
        }

        if ( typeof lng == 'string' ) {
           lng = parseFloat( lng );
        }

        addMarker(
            {
                'lat': lat,
                'lng': lng
            },
            {
                'id': data[i].id,
                'title': data[i].title,
                'address': data[i].address.address,
                'phone': data[i].phone,
                'url': data[i].url,
                'if': data[i].indoor,
                'of': data[i].outdoor,
				'ic': data[i].indoorclub,
				'oc': data[i].outdoorclub,
				'op': data[i].outdoorpublic,
                'kt': data[i].kids,
                'tdc': data[i].tdc
            }
        );

    }

    if ( mark_clust ) {
        mark_clust.clearMarkers();
    }

    mark_clust = new MarkerClusterer(map, markers, cluster_options);
    center_map( map );

}

function markerClickFn( content, location, doingwhat ) {
    return function(e) {

        if ( e ) {
            e.cancelBubble = true;
            e.returnValue = false;

            if ( e.stopPropagation ) {
                e.stopPropagation();
                e.preventDefault();
            }
        }

        var info_bubble_content = '<div>';

        info_bubble_content += '<div class="courtfinder__map__infobox__title">' + content.title + '</div>';
        info_bubble_content += '<div class="courtfinder__map__infobox__address"><a href="http://maps.google.com/?q=' + content.address + '" target="_blank">' + content.address + '</a></div>';

        if ( content.phone ) {
            info_bubble_content += '<div class="courtfinder__map__infobox__phone">' + content.phone + '</div>';
        }

        if ( content.url ) {
            info_bubble_content += '<div class="courtfinder__map__infobox__url"><a target="_blank" href="' + content.url + '">More Info</a></div>';
        }

        info_bubble_content += '<div class="courtfinder__map__infobox__feat">';

        if ( content.ic ) {

            info_bubble_content += '<span class="mark">ic</span>';

        }

        if ( content.oc ) {

            info_bubble_content += '<span class="mark">oc</span>';

        }
		if ( content.op ) {

            info_bubble_content += '<span class="mark">op</span>';

        }

        if ( content.kt ) {

            info_bubble_content += '<span class="mark">kt</span>';

        }

        if ( content.tdc ) {

            info_bubble_content += '<span class="mark">tdc</span>';

        }

		if (jQuery('body').hasClass('logged-in') && jQuery('body').hasClass('admin-bar') ) {
			info_bubble_content += '<div class="courtfinder__map__infobox__address"><a href="http://courtfinder.wpengine.com/wp-admin/post.php?post=' + content.id + '&action=edit" target="_blank">EDIT COURT</a></div>';
		}

        info_bubble_content += '</div>';

        info_bubble_content += '</div>';

        info_bubble.setPosition( location );
        info_bubble.setContent( info_bubble_content );
        info_bubble.open( map );

        if ( doingwhat == 'clicking' ) {
            map.panTo( location );
        }

        //map.setZoom( 18 );

        vm.marker = content.id;

    }
}

function center_map() {

    var bounds = new google.maps.LatLngBounds();

    jQuery.each( markers, function( i, marker ){

        var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

        bounds.extend( latlng );

    });

    if ( markers.length == 1 ) {

        map.setCenter( bounds.getCenter() );

        map.setZoom( 16 );

    } else {

        map.fitBounds( bounds );

    }

}

initMap();

import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource);

Vue.directive('selecttwo', {
    twoWay: true,
    params: [ 'selected_year', 'url', 'options' ],
    bind: function() {
        var self = this;

        var this_expr = self.expression;
        var this_mod = self.arg;

            if ( this_mod == 'provinces' ) {

                self.vm.$http.get( this.params.url ).then( function( response ) {

                    self.vm[this_mod] = response.data;

                    jQuery(self.el).select2({
                        data: self.vm[this_mod],
                        width: false
                    }).on('change', function(){
                        self.set(this.value);
                        self.vm.get_cities();
                        self.vm.selected_province_name = jQuery(':selected', self.el).text();
                    });

                }, function( response ) {

                });

            } else {

                jQuery(self.el).select2({
                    data: self.vm[this_mod],
                    width: false
                }).on('change', function(){
                    self.set(this.value);
                    self.vm.selected_city_name = jQuery(':selected', self.el).text();
                    if ( self.vm.selected_city ) {
                        self.vm.get_courts();
                    }
                });

            }

    },
    update: function(value) {
        jQuery(this.el).val(value).trigger('change');
    },
    unbind: function() {
        jQuery(this.el).off().select2('destroy');
    }
});

Vue.filter('map_link', function (value) {
    return 'http://maps.google.com/?q=' + value;
})

if( typeof document.getElementById( 'courtfinder' ) != 'undefined' && document.getElementById( 'courtfinder' ) != null ){
	var vm = new Vue({
	    ready: function() {
			if ( typeof set_postal_code !== 'undefined' && set_postal_code != '') {
				this.get_geo();
			}
	    },
	    el: '#courtfinder',
	    data: {
	        courts_all: '',
	        indoor: window.set_indoor,
			indoorclub: window.set_indoorclub,
			outdoorclub: window.set_outdoorclub,
			outdoorpublic: window.set_outdoorpublic,
	        kids: window.set_kids,
	        outdoor: window.set_outdoor,
	        tdc: window.set_tdc,
	        courts_around: '',
	        courts: '',
	        courts_nr: '',
	        provinces: '',
	        selected_province: '',
	        selected_province_name: '',
	        cities: '',
	        selected_city: '',
	        selected_city_name: '',
	        state_start: true,
	        state_sidebar_small: window.state_sidebar_small,
	        state_results: false,
	        state_geo: false,
	        state_loading: false,
	        state_all:  false,
	        marker: '',
			ico_close : window.ico_close,
			ico_chevron_right : window.ico_chevron_right,
			ico_chevron_left : window.ico_chevron_left,
			ico_location : window.ico_location
	    },
	    watch: {
	        'state_start': function() {
	            google.maps.event.trigger(map, "resize");
	        },
	        'state_sidebar_small': function() {
	            var current_center = map.getCenter();
	            google.maps.event.trigger(map, "resize");
	            map.setCenter( current_center );
	        }
	    },
	    methods: {
	        get_geo: function() {

	            getLocation();

	            if ( this.state_start == true ) {
	               this.state_start = false;
	            }

	        },

	        get_cities: function() {

	            if ( !this.selected_province ) {

	                this.cities = '';
	                this.selected_city = '';
	                this.courts = '';

	            } else {

	                this.selected_city = '';

	                this.$http.get( api_url + 'get-locations-site/?province=' + this.selected_province ).then(function (response) {

	                    this.cities = response.data;

	                    jQuery('.selecttwo_city option:not(:selected)').remove();
	                    jQuery('.selecttwo_city').select2({
	                        data: this.cities,
	                        width: false
	                    });

	                }, function (response) {

	                });

	            }

	        },

	        get_courts: function() {

	            this.state_loading = true;

	            if ( this.state_start == true ) {
	               this.state_start = false;
	            }

	            if ( !this.selected_city && !this.selected_province ) {


	                if ( this.state_geo ) {

	                   vm.get_courts_around();

	                } else {

	                    vm.get_courts_all();

	                }

	            } else {

	                if ( !this.selected_city ) {

	                    this.courts = '';
	                    this.courts_nr = '';

	                    if ( mark_clust ) {
	                        mark_clust.clearMarkers();
	                    }

	                    this.state_loading = false;

	                } else {

	                    // this.$http.get( api_url + 'get-courts/?location=' + this.selected_city + '&indoor=' + this.indoor + '&kids=' + this.kids + '&outdoor=' + this.outdoor + '&tdc=' + this.tdc ).then(function (response) {
						this.$http.get( api_url + 'get-courts/?location=' + this.selected_city + '&indoorclub=' + this.indoorclub + '&outdoorclub=' + this.outdoorclub + '&outdoorpublic=' + this.outdoorpublic ).then(function (response) {

	                        this.courts = response.data;
	                        this.courts_nr = jQuery.map(this.courts, function(n, i) { return i; }).length;

	                        this.state_results = true;

	                        displayMarkers( response.data );

	                        this.state_loading = false;

	                    }, function (response) {

	                    });

	                }

	            }

	        },

	        get_courts_all: function() {

	            this.state_loading = true;

	            this.$http.get( api_url + 'get-courts/?indoorclub=' + this.indoorclub + '&outdoorclub=' + this.outdoorclub + '&outdoorpublic=' + this.outdoorpublic ).then(function (response) {

	                this.courts = response.data;
	                this.courts_all = response.data;
	                this.courts_nr = jQuery.map(this.courts, function(n, i) { return i; }).length;

	                displayMarkers( response.data );

	                this.state_loading = false;

	            }, function (response) {

	            });

	        },

	        get_courts_around: function() {
	console.log( window )
	            this.state_loading = true;
	            this.selected_city = '';
	            this.selected_province = '';
	console.log( api_url + 'get-courts/?around=' + my_lat + ',' + my_lng +  '&indoorclub=' + this.indoorclub + '&outdoorclub=' + this.outdoorclub + '&outdoorpublic=' + this.set_outdoorpublic )
	            // this.$http.get( api_url + 'get-courts/?around=' + my_lat + ',' + my_lng +  '&indoor=' + this.indoor + '&kids=' + this.kids + '&outdoor=' + this.outdoor + '&tdc=' + this.tdc).then(function (response) {
				this.$http.get( api_url + 'get-courts/?around=' + my_lat + ',' + my_lng +  '&indoorclub=' + this.indoorclub + '&outdoorclub=' + this.outdoorclub + '&outdoorpublic=' + this.outdoorpublic ).then(function (response) {
	console.log( response )
	                this.courts = response.data;
	                this.courts_around = response.data;
	                this.courts_nr = jQuery.map(this.courts, function(n, i) { return i; }).length;
	                this.state_geo = true;
	                this.state_results = true;

	                displayMarkers( response.data );

	                this.state_loading = false;

	            }, function (response) {

	            });

	        },

	        reset_start: function() {

	            this.selected_city = '';
	            this.selected_province = '';
	            this.state_results = false;
	            this.state_geo = false;

	            vm.get_cities();
	            vm.get_courts_all()

	        },

	        open_pin: function(pin_id) {
	            var pin = String(pin_id);

	            var lookfor = markers.find(function(element, index, array) {
	                return element.title == pin;
	            });
	            google.maps.event.trigger(lookfor, 'click');

                if ( now_mobile ) {
	                this.state_sidebar_small = true;
	            }
	            
	        }

	    }
	});

}
